import React from 'react';
import { connect } from 'react-redux';
import { RootState } from '@share/utils';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { FormattedMessage, injectIntl, WrappedComponentProps } from 'react-intl';
import { SorterResult, TablePaginationConfig } from 'antd/lib/table/interface';
import { IReservationsState, getReservations, getStatic, reservationsActions } from '@share/store/slices';
import { IFilterField, IReservation, IReservationsFilters, ITextSearch } from '@share/common-types';
import SideNav from '../../components/dashboard/side-nav/component';
import { Spin } from 'antd';
import BookingsTable from './bookingsTable';

interface IMapStateToProps {
  reservationsStore: IReservationsState;
}

interface IMapDispatchToProps {
  getReservations: (status: string) => void;
  getStatic: (id: number) => void;
  setFilters: (filters: IReservationsFilters) => void;
  setPagination: (pagination: TablePaginationConfig) => void;
  setSort: (sort: SorterResult<IReservation>) => void;
  setBookingType: (bookingType: IFilterField<string>) => void;

  resetFilters: () => void;

  setTextSearch: (textSearch: ITextSearch) => void;
  setTextSearchLabel: (textSearchLabel: string) => void;
}

interface IProps extends IMapStateToProps, IMapDispatchToProps, RouteComponentProps, WrappedComponentProps { }

function BookingsComponent(props: IProps) {

  return (
    <section className="pt-3">
      <div className="container">
        <div className="row">
          <SideNav />
          <div className="col-lg-8 col-xl-9">
            <div className="card shadow-sm bg-transparent border">
              <div className="card-header bg-transparent border-bottom">
                <h4 className="card-header-title">
                  <i className="bi bi-suitcase-lg mx-2"></i><FormattedMessage id="my.bookings" />
                </h4>
              </div>
              <div className="card-body p-2 p-sm-4">
                <Spin spinning={props.reservationsStore.loading}>
                  <div className="tab-content">
                    <BookingsTable
                      title="reservation.search.title"
                      store={props.reservationsStore}
                      getReservations={props.getReservations}
                      getStatic={props.getStatic}
                      setBookingType={props.setBookingType}
                      setFilters={props.setFilters}
                      setPagination={props.setPagination}
                      setSort={props.setSort}
                      resetFilters={props.resetFilters}
                      setTextSearch={props.setTextSearch}
                      setTextSearchLabel={props.setTextSearchLabel} />
                  </div>
                </Spin>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

const mapStateToProps = (state: RootState): IMapStateToProps => {
  return {
    reservationsStore: state.reservationsStore,
  };
};

const mapDispatchToProps: IMapDispatchToProps = {
  getReservations,
  getStatic,
  setFilters: reservationsActions.setFilters,
  setPagination: reservationsActions.setPagination,
  setSort: reservationsActions.setSort,
  resetFilters: reservationsActions.resetFilters,
  setTextSearch: reservationsActions.setTextSearch,
  setTextSearchLabel: reservationsActions.setTextSearchLabel,
  setBookingType: reservationsActions.setBookingType,
};

const ComponentIntl = injectIntl(BookingsComponent);

const Bookings = connect(mapStateToProps, mapDispatchToProps)(withRouter(ComponentIntl));
export default Bookings;